export let breakpoint = {
  value: '',
  refresh() {
    this.value = window
      .getComputedStyle(document.querySelector('body'), ':before')
      .getPropertyValue('content')
      .replace(/"/g, '');
  },
};

/* 5362 */
// export function calcViewportHeight() {
//   // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
//   // Then we set the value in the --vh custom property to the root of the document
//   let vh = window.innerHeight * 0.01;
//   document.documentElement.style.setProperty('--vhbase', `${vh}px`);
// }

export function toKebabCase(str) {
  return str
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();
}

let uuid = 0;
export function clickOutside(element, callback) {
  element.uuid = ++uuid;

  function triggerCallback(e) {
    console.log('clickOutside', element);
    if (!$(e.target).closest(element).length) {
      callback();
      $(document).off(`click.${element.uuid}`);
    }
  }

  $(document).on(`click.${element.uuid}`, triggerCallback);
}

export function isValidSelector(selector) {
  if (typeof selector !== 'string') {
    return false;
  }
  try {
    $(selector);
  } catch (error) {
    return false;
  }
  return true;
}
